import { IconStar } from 'featherico';
import React from 'react';
import styles from './styles.m.less';

// iconOffset takes into consideration the padding of the button so that the icon appears close to the text
export type IconOffset = {
    top?: number; // padding-top of button
    left?: number; // padding-left of button
};

type AddUpgradeIconProps = {
    children: React.ReactElement;
    iconOffset?: IconOffset;
    handleClick?: () => void;
};

const AddUpgradeIcon = ({ children }: AddUpgradeIconProps) => {
    return (
        <div className={styles.container}>
            {children}

            <i>
                <IconStar className={styles.icon} />
            </i>
        </div>
    );
};

export default AddUpgradeIcon;
